export default __webpack_public_path__ + "static/media/bed.4f70c277.svg";